import { createClient } from 'contentful'
import type {
  ChainModifiers,
  Entry,
  EntryFieldTypes,
  EntrySkeletonType,
  LocaleCode,
} from 'contentful'

export const contentfulClient = createClient({
  space: process.env.CONTENTFUL_SPACE_ID ?? '',
  accessToken: process.env.CONTENTFUL_ACCESS_TOKEN ?? '',
})

export interface TypePolicyFields {
  title: EntryFieldTypes.Symbol
  content?: EntryFieldTypes.RichText
  metaTitle?: EntryFieldTypes.Text
  description?: EntryFieldTypes.Text
}

export type TypePolicySkeleton = EntrySkeletonType<TypePolicyFields, 'policy'>
export type TypePolicy<
  Modifiers extends ChainModifiers,
  Locales extends LocaleCode = LocaleCode
> = Entry<TypePolicySkeleton, Modifiers, Locales>

// Blog post types
export interface TypeBlogPostFields {
  title: EntryFieldTypes.Symbol
  slug: EntryFieldTypes.Symbol
  heroImage: EntryFieldTypes.AssetLink
  description: EntryFieldTypes.Text
  body?: EntryFieldTypes.RichText
  author?: EntryFieldTypes.EntryLink<TypePersonSkeleton>
  publishDate: EntryFieldTypes.Date
  tags?: EntryFieldTypes.Array<EntryFieldTypes.Symbol<string>>
  seoTitle: EntryFieldTypes.Text
  seoDescription: EntryFieldTypes.Text
}

export type TypeBlogPostSkeleton = EntrySkeletonType<TypeBlogPostFields, 'blogPost'>
export type TypeBlogPost<
  Modifiers extends ChainModifiers,
  Locales extends LocaleCode = LocaleCode
> = Entry<TypeBlogPostSkeleton, Modifiers, Locales>

export interface TypePersonFields {
  name: EntryFieldTypes.Symbol
  title: EntryFieldTypes.Symbol
  company: EntryFieldTypes.Symbol
  shortBio: EntryFieldTypes.Text
  email?: EntryFieldTypes.Symbol
  phone?: EntryFieldTypes.Symbol
  facebook?: EntryFieldTypes.Symbol
  twitter?: EntryFieldTypes.Symbol
  github?: EntryFieldTypes.Symbol
  image?: EntryFieldTypes.AssetLink
}

export type TypePersonSkeleton = EntrySkeletonType<TypePersonFields, 'person'>
export type TypePerson<
  Modifiers extends ChainModifiers,
  Locales extends LocaleCode = LocaleCode
> = Entry<TypePersonSkeleton, Modifiers, Locales>

// Function to get blog posts
export const getBlogPosts = async () => {
  try {
    const entries = await contentfulClient.getEntries<TypeBlogPostSkeleton>({
      content_type: 'blogPost',
    })
    return entries
  } catch (error) {
    console.error('Error fetching blog posts:', error)
    return null
  }
}
